import { render, staticRenderFns } from "./SynatecModalManual.vue?vue&type=template&id=0132cfe4&"
import script from "./SynatecModalManual.vue?vue&type=script&lang=js&"
export * from "./SynatecModalManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports